import {
    makeHttpRequest,
    mapDatabaseParamsFromServer,
    mapPaginationParamsToServer,
} from "@/shared";

import { mapPaymentTypesFromServer } from "./mappers/mapPaymentTypesFromServer";

export const getPaymentTypes = async (paginationParams) => {
    const response = (
        await makeHttpRequest({
            url: "/payment-type",
            method: "GET",
            params: mapPaginationParamsToServer(paginationParams),
        })
    ).data;

    return {
        data: mapPaymentTypesFromServer(response.data),
        ...mapDatabaseParamsFromServer(response),
    };
};
